import AdminConsoleDeleteDialog from "../../../base/AdminConsoleDeleteDialog";
import { adminConsoleSection } from "../../../../../../../../utils/constants";
import { deleteAcPage } from "../../../../../../../../axios/api/services";

const AdminConsoleSectionDeleteDialog = () => {
  return (
    <AdminConsoleDeleteDialog
      section={adminConsoleSection.page}
      title={"t.ac.page.delete.dialog"}
      message={"m.delete.ac.page.warning.message"}
      serviceFn={deleteAcPage}
    />
  );
};
export default AdminConsoleSectionDeleteDialog;
